/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DispoRejectBookingMutationVariables = {
    id: string;
};
export type DispoRejectBookingMutationResponse = {
    readonly rejectBooking: {
        readonly bookingId: string;
    };
};
export type DispoRejectBookingMutation = {
    readonly response: DispoRejectBookingMutationResponse;
    readonly variables: DispoRejectBookingMutationVariables;
};



/*
mutation DispoRejectBookingMutation(
  $id: String!
) {
  rejectBooking(id: $id) {
    bookingId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Booking",
    "kind": "LinkedField",
    "name": "rejectBooking",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bookingId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DispoRejectBookingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DispoRejectBookingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2fed3cd5441f726ee55b164a47103157",
    "id": null,
    "metadata": {},
    "name": "DispoRejectBookingMutation",
    "operationKind": "mutation",
    "text": "mutation DispoRejectBookingMutation(\n  $id: String!\n) {\n  rejectBooking(id: $id) {\n    bookingId\n  }\n}\n"
  }
};
})();
(node as any).hash = '58c6e3be067635119fa24eb30690f79b';
export default node;
